
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { restoreScrollPos } from '@unreserved-frontend-v2/ui/hooks/use-scroll-resortation/use-scroll-restoration';
/**
 * This hook is for scroll manipulation & restoration purposes
 */
const useScrollControls = (scrollOnChangeAmount: number, isFetching?: boolean, isFetchedAfterMount?: boolean, isQueryDirty?: boolean) => {
    const { asPath, events } = useRouter();
    const [scrollRestored, setScrollRestored] = useState(false);
    useEffect(() => {
        if (isFetchedAfterMount && !scrollRestored) {
            restoreScrollPos(asPath);
            setScrollRestored(true);
        }
    }, [isFetchedAfterMount, asPath, scrollRestored, setScrollRestored]);
    // Called when a page is changed/paginated
    // Also called when a filter is changed
    useEffect(() => {
        const scroll = (_: string, { shallow }: {
            shallow: boolean;
        }) => {
            if (window.scrollY >= scrollOnChangeAmount && shallow) {
                // If pagination was called, it is safe to assume scroll has been restored
                setScrollRestored(true);
                // This is to keep the filters fixed to the top when changing pages
                // NOTE: disabling this for now as it caused a race condition which sometimes caused scroll restoration to fail
                //   leaving the user stuck at the bottom of the screen (very rare case):
                //   https://github.com/UnreservedInc/unreserved-frontend-v2/issues/1361
                // because scroll={false} is required on Links when using this scroll restoration mechanism, when it fails it
                // leaves the user at the bottom of the screen. using scroll={true} on links will override scroll restoration
                // window.scroll(0, scrollOnChangeAmount)
            }
        };
        events.on('routeChangeComplete', scroll);
        return () => {
            events.off('routeChangeComplete', scroll);
        };
    }, [events, scrollOnChangeAmount]);
    useEffect(() => {
        // Only stop scrolling if fetching & queryParams are dirty (clientside updated after mount)
        if (isFetching && isQueryDirty) {
            document.body.classList.add('overflow-hidden');
        }
        else {
            document.body.classList.remove('overflow-hidden');
        }
    }, [isFetching, isQueryDirty]);
};
export default useScrollControls;

    async function __Next_Translate__getServerSideProps__1955d79de05__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//[listing]/use-scroll-controls',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1955d79de05__ as getServerSideProps }
  